import { ButtonGroup, Pagination as ChackraPagination } from '@chakra-ui/react';
import { useCallback } from 'react';

import type { PaginationParams } from 'ui/shared/pagination/types';

import IconSvg from 'ui/shared/IconSvg';

import { Button } from './button';

export const Pagination = (props: PaginationParams) => {

  const { page, onNextPageClick, onPrevPageClick, hasPages, hasNextPage, canGoBackwards, isLoading } = props;

  const showSkeleton = page === 1 && !hasPages && isLoading;

  const render = useCallback((page: { type: 'page'; value: number }) => renderPageItem({ page, showSkeleton }), [ showSkeleton ]);

  const onPageChange = useCallback(({ page: newPage }: { page: number }) => {
    if (newPage < page) {
      onPrevPageClick();
    } else {
      onNextPageClick();
    }
  }, [ onNextPageClick, onPrevPageClick, page ]);

  function renderPageItem({ page, showSkeleton }: {
    page: {
      type: 'page';
      value: number;
    };
    showSkeleton: boolean;
  }) {
    return (
      <Button
        variant="pagination"
        size="sm"
        loadingSkeleton={ showSkeleton }
      >
        { page.value }
      </Button>
    );
  }

  return (
    <ChackraPagination.Root
      page={ page }
      onPageChange={ onPageChange }
      // pageSize={ 20 }
      count={ 50 }
    >
      <ButtonGroup size="2xs" variant="pagination" gap="1">
        <ChackraPagination.PrevTrigger asChild>
          <Button
            size="sm"
            aria-label="Prev page"
            variant="plain"
            disabled={ !canGoBackwards || isLoading || page === 1 }
            loadingSkeleton={ showSkeleton }
          >
            <IconSvg name="arrows/east-mini" boxSize={ 5 }/>
            Previous
          </Button>
        </ChackraPagination.PrevTrigger>
        <ChackraPagination.Items
          render={ render }
        />
        <ChackraPagination.NextTrigger asChild>
          <Button
            size="sm"
            aria-label="Next page"
            variant="plain"
            disabled={ !hasNextPage || isLoading }
            loadingSkeleton={ showSkeleton }
          >
            Next
            <IconSvg name="arrows/east-mini" boxSize={ 5 } transform="rotate(180deg)"/>
          </Button>
        </ChackraPagination.NextTrigger>
      </ButtonGroup>
    </ChackraPagination.Root>
  );
};
